import { useQuery, UseQueryResult } from "@tanstack/react-query"
import ResponseError from "#/types/responseError"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"

export interface ExistingPreAuth {
  id: number
  createdDate: string
  coveredSwipeAmount: number
  memberOOPAmount: number
  currencyCode: string
  expirationDate: string
  PreAuthAnswersId: string
  expenseId: number
}

export interface ExistingPreAuthsResponse {
  preAuths: ExistingPreAuth[]
}

export function useExistingPreAuth(): UseQueryResult<ExistingPreAuthsResponse, ResponseError> {
  return useQuery<ExistingPreAuthsResponse, ResponseError>(
    ["getExistingPreAuths"],
    async () => {
      return carrotClient.getExistingPreAuths()
    },
    {
      retry: buildCarrotApiRetryPolicy(3),
      refetchOnWindowFocus: false
    }
  )
}
